export { App as default } from '@guiker/my-investments-main-mfe'
